import Logo from '@/components/atoms/Logo'
import Container from '@/components/atoms/Container'

import HeaderTriggerButton from './HeaderTriggerButton'
import HeaderMenu from './HeaderMenu'
import HeaderActions from './HeaderActions'

import styles from './Header.module.scss'

const Header = ({ minified }: { minified?: boolean }) => (
  <div className={styles.header}>
    <Container>
      <div className={styles.headerContainer}>
        <Logo className={styles.logo} />
        {minified ? null : (
          <>
            <HeaderTriggerButton />
            <div className={styles.headerInteractions}>
              <HeaderMenu />
              <HeaderActions />
            </div>
          </>
        )}
      </div>
    </Container>
  </div>
)

export default Header
